exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-personal{position:relative}.form-personal .toggle-line{margin:6px 0}.form-personal .toggle-line .toggle-trigger{width:100%}.form-personal .toggle-line .toggle-trigger .el-icon-arrow-down{transition:transform .2s ease}.form-personal .toggle-line .toggle-trigger .turn-around{transform:rotate(180deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-243d9f8a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/resumeDetail/items/personal.vue
// module id = 822
// module chunks = 23